import { createSlice } from '@reduxjs/toolkit';

let timeoutHolder;


const defaultSettings = require('./defaultSettings');


const defaultMqttCheck = {
	isChecking: false,
	usernameAvailable: null,	// has to be null when not active
	// hasChanged: false
}


const initialState = {
	data: defaultSettings,
	mqttCheck: defaultMqttCheck,
	tempStatus: 'saved'
}



const tempSettingsSlice = createSlice({
    name: 'tempSettings',
    initialState,
    reducers: {
		
		// Wholesale replace, mirroring settings/index.js's setSettings —
		// this is used for full hydrate/restore (setBothSettings,
		// restoreSettings). A field-by-field merge here left stale keys
		// from the previous data object (originally the shared
		// defaultSettings) behind whenever the incoming payload omitted
		// them — e.g. a fresh account's server response leaving out
		// never-saved booleans like smsEnabled. That produced a
		// permanent settings.data/tempSettings.data mismatch (undefined
		// vs the old default's false), which read as "dirty" on a
		// completely untouched page. Single-field edits (like the
		// deleteOnExpiration toggle) use editTempSettings instead, which
		// is a real partial update, not this hydrate path.
		setTempSettings: (state, action) => {
			state.data = action.payload;
			state.tempStatus = 'saved';
		},

		// tempSettingsSaved: () => {
		// 	state.tempStatus = 'saved';
		// },

		editTempSettings: (state, action) => {
			
			const {key, value} = action.payload;
			state.data[key] = value;
			state.tempStatus = 'unsaved'
			// if (key === 'mqttUsername' || key == 'mqttPassword') {
			// 	state.mqttCheck.hasChanged = true;
			// }
			state.mqttCheck.isChecking = false;	
			state.mqttCheck.usernameAvailable = null;
		},
		
		setUsernameCheckStatus: (state, action) => {
			const {isChecking, usernameAvailable} = action.payload
			// console.log("action.payload:", action.payload);
			for (var keys in action.payload) state.mqttCheck[keys] = action.payload[keys];
		},

		// Credentials are now generated server-side (crypto.randomBytes) and
		// fetched via the generateCredential thunk in actions.js. This reducer
		// just drops the returned value into the right field. The plaintext no
		// longer lives in the client's RNG -- and it's no longer logged.
		setCredential: (state, action) => {
			const { type, value } = action.payload;
			if (type == "mqtt")  state.data.mqttPassword = value;
			if (type == "http1") state.data.httpAuthKey1 = value;
			if (type == "http2") state.data.httpAuthKey2 = value;
			if (type == "http3") state.data.httpAuthKey3 = value;
			state.tempStatus = 'unsaved';	// need this for genPass
		},

		clearFlags: (state) => {
			console.log("clearing flags");
			state.mqttCheck.isChecking = false;
			state.mqttCheck.usernameAvailable = null;	// has to be null when not active
			// state.mqttCheck.hasChanged = false;
			state.tempStatus = 'saved';
		}
    },
});

export const { setTempSettings, editTempSettings, setUsernameCheckStatus, setCredential, clearFlags } = tempSettingsSlice.actions;
export default tempSettingsSlice.reducer;